import React from 'react';
import { Check, CreditCard, Sparkles, ShieldCheck } from 'lucide-react';
import { Header } from '../components/Header.js';
import { EduCard } from '../components/EduCard.js';
import { EduButton } from '../components/EduButton.js';
import { EduBadge } from '../components/EduBadge.js';

export const MyPlan: React.FC = () => {
  return (
    <div>
      <Header
        title="Meu Plano"
        subtitle="Gerencie as características e limites da sua assinatura contratada"
      />

      <div className="p-8 max-w-5xl mx-auto space-y-6">
        <EduCard
          title={
            <div className="flex items-center gap-2">
              <CreditCard className="text-brand-primary" size={20} />
              <span>Assinatura Ativa: Plano Pro</span>
            </div>
          }
          subtitle="Renovação automática mensal"
          action={<EduBadge variant="success" dot>Ativo</EduBadge>}
        >
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 py-4">
            <div className="border border-bdr p-4 rounded-xl bg-surface-secondary">
              <span className="text-xs text-txt-secondary block">Franquia Contratada</span>
              <span className="text-3xl font-bold text-txt-primary mt-1 block">30</span>
              <span className="text-xs text-txt-muted">videoaulas por mês</span>
            </div>

            <div className="border border-bdr p-4 rounded-xl bg-surface-secondary">
              <span className="text-xs text-txt-secondary block">Duração Máxima</span>
              <span className="text-3xl font-bold text-txt-primary mt-1 block">30 min</span>
              <span className="text-xs text-txt-muted">por videoaula produzida</span>
            </div>

            <div className="border border-bdr p-4 rounded-xl bg-surface-secondary">
              <span className="text-xs text-txt-secondary block">Vozes Neurais</span>
              <span className="text-xl font-bold text-brand-primary mt-1 block">Faber & Cadu</span>
              <span className="text-xs text-txt-muted">Modelos Piper TTS em PT-BR</span>
            </div>
          </div>

          <div className="mt-6 border-t border-bdr pt-6">
            <h4 className="text-sm font-semibold text-txt-primary mb-3">
              Recursos incluídos no seu plano
            </h4>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-2.5 text-xs text-txt-secondary">
              <li className="flex items-center gap-2">
                <Check size={16} className="text-status-success shrink-0" />
                <span>Renderização em alta resolução HD 1280x720 25 FPS</span>
              </li>
              <li className="flex items-center gap-2">
                <Check size={16} className="text-status-success shrink-0" />
                <span>Compatibilidade total com pacotes didáticos Estuda.01 (.ZIP)</span>
              </li>
              <li className="flex items-center gap-2">
                <Check size={16} className="text-status-success shrink-0" />
                <span>Exportação completa em formato MP4 (vídeo) e WAV (áudio)</span>
              </li>
              <li className="flex items-center gap-2">
                <Check size={16} className="text-status-success shrink-0" />
                <span>Até 50 projetos simultâneos cadastrados</span>
              </li>
              <li className="flex items-center gap-2">
                <Check size={16} className="text-status-success shrink-0" />
                <span>Armazenamento em nuvem de videoaulas com download permanente</span>
              </li>
              <li className="flex items-center gap-2">
                <Check size={16} className="text-status-success shrink-0" />
                <span>Suporte técnico prioritário para a equipe pedagógica</span>
              </li>
            </ul>
          </div>

          <div className="mt-8 p-4 bg-brand-light border border-orange-200 rounded-xl flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Sparkles className="text-brand-primary shrink-0" size={24} />
              <div>
                <h5 className="text-sm font-bold text-brand-graphite">Precisa de mais franquia de aulas?</h5>
                <p className="text-xs text-txt-secondary">
                  Faça upgrade para o Plano Business (100 aulas/mês) ou adquira pacotes de bônus avulsos.
                </p>
              </div>
            </div>
            <EduButton variant="primary" size="sm">
              Falar com Consultor
            </EduButton>
          </div>
        </EduCard>
      </div>
    </div>
  );
};
